var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookshelf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22H5C3.89543 22 3 21.1046 3 20V16.75H11.25V22ZM7 18.25C6.58579 18.25 6.25 18.5858 6.25 19C6.25 19.4142 6.58579 19.75 7 19.75H9C9.41421 19.75 9.75 19.4142 9.75 19C9.75 18.5858 9.41421 18.25 9 18.25H7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 16.75V22H19C20.1046 22 21 21.1046 21 20V16.75H12.75ZM14.25 19C14.25 18.5858 14.5858 18.25 15 18.25H17C17.4142 18.25 17.75 18.5858 17.75 19C17.75 19.4142 17.4142 19.75 17 19.75H15C14.5858 19.75 14.25 19.4142 14.25 19Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15.25V8V2H19C20.1046 2 21 2.89543 21 4V15.25H19.7005L20.3542 12.8102C20.4257 12.5434 20.2674 12.2693 20.0006 12.1978L19.0347 11.939C18.768 11.8675 18.4938 12.0258 18.4223 12.2925L17.6459 15.1903C17.6406 15.2102 17.6365 15.2301 17.6337 15.25H16.7005L17.3542 12.8102C17.4257 12.5434 17.2674 12.2693 17.0006 12.1978L16.0347 11.939C15.768 11.8675 15.4938 12.0258 15.4223 12.2925L14.6459 15.1903C14.6406 15.2102 14.6365 15.2301 14.6337 15.25H12.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.25V8.75H3V15.25H11.25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.25V2H5C3.89543 2 3 2.89543 3 4V7.25H4.29978L3.64601 4.81011C3.57454 4.54338 3.73283 4.26921 3.99956 4.19774L4.96549 3.93892C5.23222 3.86745 5.50639 4.02574 5.57786 4.29247L6.35432 7.19025C6.35965 7.21015 6.36371 7.2301 6.36653 7.25H7.29978L6.64601 4.81011C6.57454 4.54338 6.73283 4.26921 6.99956 4.19774L7.96549 3.93892C8.23222 3.86745 8.50639 4.02574 8.57786 4.29247L9.35432 7.19025C9.35965 7.21015 9.36371 7.2301 9.36653 7.25H11.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookshelf);
export default __webpack_public_path__ + "static/media/bookshelf.371d083d7c89f6011706ca2685d3b7bb.svg";
export { ForwardRef as ReactComponent };